import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=164392a4&scoped=true"
import script from "./CoverImage.vue?vue&type=script&lang=js"
export * from "./CoverImage.vue?vue&type=script&lang=js"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=164392a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164392a4",
  null
  
)

export default component.exports